import React from 'react';

import Typography from '@mui/material/Typography';

import styled from 'styled-components';

import Box from '@mui/material/Box';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import PayDepositGraphic from '../img/pay-deposit.svg';
import RecentUpdatesGraphic from '../img/recent-updates.svg';

import ComponentCarouselContainer from '../containers/ComponentCarouselContainer';

import {
  PROPY_SPACE_GREY_LIGHT,
  PROPY_SPACE_GREY_DARK,
  PROPY_BLACK,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.mobile ? 'column-reverse' : 'row'};
`

const TypographyContainer = styled.div`
  max-width: ${props => props.mobile ? '300px' : '500px'};
  margin-left: ${props => props.mobile ? 'auto' : '0px'};
  margin-right: ${props => props.mobile ? 'auto' : '0px'};
  margin-bottom: ${props => props.mobile ? props.theme.spacing(4) : '0px'};
`

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const LicensedTitleAndEscrow = ({ isConsideredMobile }) => {
  return (
    <ZoneContainer>
      <Zone mobile={isConsideredMobile}>
        <ComponentCarouselContainer
          autoAnimate={true}
          height={isConsideredMobile ? '290px' : '400px'}
          width={'100%'}
          maxWidth={isConsideredMobile ? '300px' : '455px'}
          components={[
            <Box
              component={PayDepositGraphic}
              style={{...(isConsideredMobile && {maxWidth: 300, maxHeight: 250})}}
            />,
            <Box
              component={RecentUpdatesGraphic}
              style={{...(isConsideredMobile && {maxWidth: 300, maxHeight: 250})}}
            />
          ]}
        />
        <TypographyContainer mobile={isConsideredMobile}>
          <Typography sx={{ fontFamily: fonts.spaceGrotesk, textTransform: 'uppercase', color: PROPY_SPACE_GREY_LIGHT, letterSpacing: '0.12em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>The best platform for agents</Typography>
          <TypographySpacer>
            <Typography variant="h4" sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}>Licensed Title and Escrow</Typography>
          </TypographySpacer>
          <TypographySpacer>
            <Typography sx={{ fontFamily: fonts.robotoMono, color: PROPY_SPACE_GREY_DARK, letterSpacing: '-0.01em', fontWeight: 300, textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>
              Enjoy effortless updates to all parties. Your clients will always know what to do and what’s next.
            </Typography>
          </TypographySpacer>
        </TypographyContainer>
      </Zone>
    </ZoneContainer>
  );
};

export default LicensedTitleAndEscrow;